import React from "react";
import { Row, Col } from "react-bootstrap";
import TooltipDesc from "../../TooltipDesc";
import { isMobile } from "react-device-detect";
//1234
function HistoryOfTransactions({ itemtransactions, item, typeOfModalWaranty, isCanceled }) {
  return (
    <>
      {typeOfModalWaranty == "CancelStatus" && isCanceled && !!item.amusementServiceReserveItemTicketSourceId &&
        <div
          style={{
            borderBottom: "1px solid black"
          }}
          className="pb-3 my-3 pe-5"
        >
          - وضعیت منبع بلیط به <strong>{item.strStatus}</strong> تغییر یافته است.
        </div>
      }
      <div>
        {itemtransactions && itemtransactions.length > 0 ? (
          itemtransactions?.map((i, idx) => {
            return (
              <div
                key={idx}
                className="my-2 col-12 rounded border p-3"
                style={
                  i.isDeleted
                    ? { opacity: "0.5", backgroundColor: "#ffffff" }
                    : { opacity: "1", backgroundColor: "#ffffff" }
                }
              >
                <Row>
                  <Col xs="5" className="font-weight-bold">
                    نوع تراکنش:
                  </Col>
                  <Col>
                    {" "}
                    <p className="text-center">{i.typeS}</p>
                  </Col>
                </Row>
                <Row>
                  <Col xs="5" className="font-weight-bold">
                    شرکت:
                  </Col>
                  <Col>
                    {" "}
                    <p className="text-center">{i.supplierCompanyName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col xs="5" className="font-weight-bold">
                    اپراتور:
                  </Col>
                  <Col>
                    <p className="text-center"> {i.createdByName}</p>
                  </Col>
                </Row>
                <Row>
                  <Col xs="5" className="font-weight-bold">
                    مبلغ:
                  </Col>
                  <Col>
                    <p
                      className="text-center"
                      style={i.typeS == "دریافت_از_گارانتی_کننده" ? { color: "red" } : { color: "black" }}
                    >{`${i.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}تومان`}</p>
                  </Col>
                </Row>
                <Row>
                  <Col xs="5" className="font-weight-bold">
                    تاریخ:
                  </Col>
                  <Col>
                    <p className="text-center">
                      {i.completionDate} - {i.completionTime}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col xs="5" className="font-weight-bold">
                    تاریخ ثبت:
                  </Col>
                  <Col className="text-center" style={{ fontSize: "11px" }}>
                    <p>{i.created} </p>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col xs="5" className="font-weight-bold">
                    {" "}
                    توضیحات:
                  </Col>
                  <Col className="text-center">
                    <p>{i.isDeleted ? "حذف شده " : i.description != null ? i.description : "--"}</p>
                  </Col>
                </Row>
              </div>
            );
          })
        ) : (
          <div className="p-5 rounded w-100 mx-2 bg-white">{typeOfModalWaranty == "payToWaranty" ? "لطفا مبلغ پرداختی خود را ثبت نمایید" : typeOfModalWaranty != "receiveFromWaranty" ? "تراکنشی ثبت نشده است" : "لطفا مبلغ دریافتی خود را ثبت نمایید"}</div>
        )}
      </div>
    </>
  );
}

export default HistoryOfTransactions;
